(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lite-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lite-review-carousel')) {
  customElements.define('lite-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-review-track]');
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index)));
      this.track.addEventListener('scroll', () => {
        if (matchMedia('(min-width:750px)').matches) return;
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      }, {passive:true});
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.select(index);
      });
    }
    select(index) {
      if (matchMedia('(max-width:749px)').matches) {
        this.cards.forEach(card => card.style.order = '');
        this.track.scrollTo({left:index * this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      } else {
        this.cards.forEach((card, i) => card.style.order = (i - index + this.cards.length) % this.cards.length);
      }
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
